module.exports = __webpack_public_path__ + "static/media/insights.952b5c83.svg";